import { ItemScheme } from '../../Form/MagicFormItem';
import { MagicField } from '../../../Enums/MagicField.enum';
import { FormSelectValue } from '../../../Modules/MagicForm/Interfaces/FormSelectValue';
import { FormValues } from '../../../Modules/MagicForm/Interfaces/FormValues';
import { Moment } from 'moment';
import { SelectValue } from '../../Base/Select/Select';

export interface SearchMedicamentRecordPatientFormValues {
	firstName?: string;
	lastName?: string;
	dateOfBirth?: Moment;
	months: SelectValue;
	useAddress?: boolean;
	useDocument?: boolean;
	address?: {
		street: string;
		descriptiveNumber: string;
		guideNumber: string;
		city: string;
		postCode: string;
	};
	identificationDocument?: {
		documentType: FormSelectValue;
		documentNumber: string;
	};
}

export const getMedicamentRecordPatientFormScheme = (
	personalDocumentTypes: FormSelectValue[],
): ItemScheme[] => {
	return [
		{
			type: MagicField.TEXT_FIELD,
			key: 'firstName',
			title: 'base.shared.firstName',
			settings: {
				required: true,
			},
		},
		{
			type: MagicField.TEXT_FIELD,
			key: 'lastName',
			title: 'base.shared.lastName',
			settings: {
				required: true,
			},
		},
		{
			type: MagicField.DATEPICKER,
			key: 'dateOfBirth',
			title: 'base.shared.dateOfBirth',
			settings: {
				required: true,
			},
		},
		{
			type: MagicField.SELECT,
			key: 'months',
			title: 'base.showTimePeriod',
			settings: {
				required: true,
			},
			children: [
				{ key: '1', value: '1', title: 'base.lastMonth' },
				{ key: '3', value: '3', title: 'base.threeMoths' },
				{ key: '6', value: '6', title: 'base.sixMonths' },
				{ key: '12', value: '12', title: 'base.oneYear' },
				{ key: '24', value: '24', title: 'base.twoYears' },
				{ key: '36', value: '36', title: 'base.threeYears' },
				{ key: '60', value: '60', title: 'base.fiveYears' },
			],
		},
		{
			type: MagicField.CHECKBOX,
			key: 'useDocument',
			title: 'base.id',
		},
		{
			type: MagicField.CONDITION,
			subType: 'view',
			settings: {
				rules: [
					{
						formControlKey: 'useDocument',
						rule: 'equal',
						value: true,
					},
				],
			},
			children: [
				{
					type: MagicField.CONTAINER,
					key: 'identificationDocument',
					settings: {
						showLine: true,
					},
					children: [
						{
							type: MagicField.SELECT,
							key: 'documentType',
							title: 'base.personalIdentificationType',
							children: personalDocumentTypes,
							settings: {
								required: true,
							},
						},
						{
							type: MagicField.TEXT_FIELD,
							key: 'documentNumber',
							title: 'base.personalIdentificationNumber',
							settings: {
								required: true,
							},
						},
					],
				},
			],
		},
		{
			type: MagicField.CHECKBOX,
			key: 'useAddress',
			title: 'base.enterAddress',
		},
		{
			type: MagicField.CONDITION,
			subType: 'view',
			settings: {
				rules: [
					{
						formControlKey: 'useAddress',
						rule: 'equal',
						value: true,
					},
				],
			},
			children: [
				{
					type: MagicField.CONTAINER,
					key: 'address',
					settings: {
						showLine: true,
					},
					children: [
						{
							type: MagicField.TEXT_FIELD,
							key: 'street',
							title: 'base.shared.street',
							settings: {
								required: true,
							},
						},
						{
							type: MagicField.HSTACK,
							children: [
								{
									type: MagicField.TEXT_FIELD,
									key: 'descriptiveNumber',
									title: 'base.houseNumber',
									settings: {
										required: true,
										errorMessage:
											'validation.searchMedicamentRecordPatientsData.descriptiveNumber',
									},
								},
								{
									type: MagicField.TEXT_FIELD,
									key: 'guideNumber',
									title: 'base.landmarkNumber',
								},
							],
						},
						{
							type: MagicField.TEXT_FIELD,
							key: 'city',
							title: 'component.ePrescription.village',
							settings: {
								required: true,
							},
						},
						{
							type: MagicField.TEXT_FIELD,
							key: 'postCode',
							title: 'base.shared.postCode',
							settings: {
								required: true,
							},
						},
					],
				},
			],
		},
	];
};
